"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
function getOffset(node) {
    var _a = node.getBoundingClientRect(), left = _a.left, top = _a.top;
    var offsetLeft = window.pageXOffset || document.documentElement.scrollLeft;
    var offsetTop = window.pageYOffset || document.documentElement.scrollTop;
    return { left: left + offsetLeft, top: top + offsetTop };
}
exports.getOffset = getOffset;
function smoothScroll(_a) {
    var left = _a.left, top = _a.top;
    return 'scrollBehavior' in document.documentElement.style
        ? window.scroll({ behavior: 'smooth', left: left, top: top })
        : window.scroll(left, top);
}
exports.smoothScroll = smoothScroll;
function scroll(node) {
    smoothScroll(getOffset(node));
}
var ScrollTo = (function (_super) {
    __extends(ScrollTo, _super);
    function ScrollTo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ScrollTo.prototype, "scroll", {
        get: function () {
            return this.props.scroll || scroll;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollTo.prototype, "child", {
        get: function () {
            if (Array.isArray(this.props.renderFirstChild)) {
                return this.props.renderFirstChild[0];
            }
            return React.createElement("span", { "data-tag": this.props.tag });
        },
        enumerable: true,
        configurable: true
    });
    ScrollTo.prototype.handleScroll = function () {
        if (!this.props.disabled) {
            this.scroll(ReactDOM.findDOMNode(this));
        }
    };
    ScrollTo.prototype.componentDidMount = function () {
        this.handleScroll();
    };
    ScrollTo.prototype.componentDidUpdate = function () {
        this.handleScroll();
    };
    ScrollTo.prototype.render = function () {
        return this.child;
    };
    return ScrollTo;
}(React.Component));
ScrollTo.defaultProps = {
    tag: '',
    scroll: scroll
};
exports.default = ScrollTo;
//# sourceMappingURL=ScrollTo.js.map


//////////////////
// WEBPACK FOOTER
// ../player-scroll-to/build/control/ScrollTo.js
// module id = 380
// module chunks = 0